import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SavedCartsAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SavedCartsAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 36 36">
      <path
        d="M9 9.99994H12.4639L12.9481 12.1603M12.9481 12.1603C12.9481 12.1603 26.1997 12.0161 26.3526 12.1603C26.4782 12.2788 24.1667 19.5316 24.1667 19.5316C24.1667 19.5316 24.1667 19.5316 24.1622 19.5316C24.1622 19.5316 22.8173 19.5331 22.4154 19.5316C20.4506 19.5245 15.5385 19.5029 14.3676 19.5316M12.9481 12.1603L14.3676 19.5316M14.3676 19.5316C12.9623 19.5661 12.8001 21.3726 14.3676 21.5417C14.6373 21.5612 24.4017 21.5417 24.4017 21.5417"
        stroke="#503291"
        strokeLinecap="round"
      />
      <circle cx={15.7402} cy={24.3511} r={1.14888} stroke="#503291" />
      <circle cx={22.6059} cy={24.3511} r={1.14888} stroke="#503291" />
    </Icon>
  )
}
export default SavedCartsAccountIcon
